// extracted by mini-css-extract-plugin
module.exports = {"Card":"Day_Card__fy_v0","cardBody":"Day_cardBody__1HfbC","cardDate":"Day_cardDate__3Cdkg","cardTitle":"Day_cardTitle__rWckd","cardText":"Day_cardText__B8BpW"};